import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const companyInformation = (brand) => (_jsxs("span", { children: [brand, " is a trading name of Awaze Vacation Rentals Ltd. ", _jsx("br", {}), " Registered in England and Wales. Company Registration Number 00965389. VAT Registration Number: GB 598 22 99 77"] }));
export const footerCottagesLabels = {
    id: 'Cottages footer',
    panels: [
        {
            title: 'Need help?',
            text: 'If you can’t find the information you need in the Frequently Asked Questions section, our team will be happy to assist.',
            cta: {
                link: '/info/help',
                title: 'FAQs, help and support',
                text: 'FAQs, help and support',
                icon: 'faq',
            },
        },
        {
            title: 'Partner with us',
            text: 'Thinking of letting your property? Benefit from partnering with the UK’s leading managed holiday letting agency.',
            cta: {
                link: '/let-your-property',
                title: 'Let your property',
                text: 'Let your property',
                icon: 'houseHeart',
            },
        },
        {
            title: 'Book with confidence',
            text: "We're committed to maintaining a high standard of service to our customers by abiding by ABTA's Code of Conduct",
            secondaryText: 'Membership numbers Y0662/L4801',
            icon: 'abta',
            cta: {
                link: '/book-with-confidence',
                title: 'Read full details',
                text: 'Read full details',
                icon: 'shield',
            },
        },
    ],
    menu: {
        menuItems: [
            {
                link: {
                    displayText: 'Company',
                    openInNew: false,
                },
                highlight: false,
                subMenu: [
                    {
                        highlight: false,
                        link: {
                            displayText: 'About Cottages.com',
                            href: '/info/about',
                            openInNew: false,
                        },
                    },
                    {
                        highlight: false,
                        link: {
                            displayText: 'About Awaze',
                            href: 'https://www.awaze.co.uk/',
                            openInNew: true,
                        },
                    },
                    {
                        highlight: false,
                        link: {
                            displayText: 'Press and media',
                            href: '/press',
                            openInNew: false,
                        },
                    },
                    {
                        highlight: false,
                        link: {
                            displayText: 'Gender pay gap',
                            href: 'https://www.awaze.co.uk/gender-pay',
                            openInNew: true,
                        },
                    },
                    {
                        highlight: false,
                        link: {
                            displayText: 'Contact us',
                            href: '/contact-us-email',
                            openInNew: false,
                        },
                    },
                ],
            },
            {
                link: {
                    displayText: 'Customer Information',
                    openInNew: false,
                },
                highlight: false,
                subMenu: [
                    {
                        highlight: false,
                        link: {
                            displayText: 'FAQs, help and support',
                            href: '/info/help',
                            openInNew: false,
                        },
                    },
                    {
                        highlight: false,
                        link: {
                            displayText: 'Important holiday information',
                            href: '/info/important-holiday-information',
                            openInNew: false,
                        },
                    },
                    {
                        highlight: false,
                        link: {
                            displayText: 'Insurance',
                            href: '/info/travel-insurance',
                            openInNew: false,
                        },
                    },
                    {
                        highlight: false,
                        link: {
                            displayText: 'Ferry travel',
                            href: '/info/ferry-travel',
                            openInNew: false,
                        },
                    },
                    {
                        highlight: false,
                        link: {
                            displayText: 'Booking conditions',
                            href: '/legal/booking-conditions',
                            openInNew: false,
                        },
                    },
                    {
                        highlight: false,
                        link: {
                            displayText: 'Buy holiday gift vouchers',
                            href: 'https://www.holiday-voucher.com/',
                            openInNew: true,
                        },
                    },
                ],
            },
            {
                link: {
                    displayText: 'Inspiration',
                    openInNew: false,
                },
                highlight: false,
                subMenu: [
                    {
                        highlight: false,
                        link: {
                            displayText: 'Travel guides',
                            href: '/inspire-and-explore',
                            openInNew: false,
                        },
                    },
                    {
                        highlight: false,
                        link: {
                            displayText: 'Our breaks',
                            href: '/breaks',
                            openInNew: false,
                        },
                    },
                    {
                        highlight: false,
                        link: {
                            displayText: 'Our collections',
                            href: '/collections',
                            openInNew: false,
                        },
                    },
                    {
                        highlight: false,
                        link: {
                            displayText: 'Seasonal collection',
                            href: '/seasonal',
                            openInNew: false,
                        },
                    },
                    {
                        highlight: false,
                        link: {
                            displayText: 'Blog',
                            href: 'https://blog.cottages.com/',
                            openInNew: false,
                        },
                    },
                    {
                        highlight: false,
                        link: {
                            displayText: 'cottages.com TV',
                            href: '/tv',
                            openInNew: false,
                        },
                    },
                ],
            },
            {
                link: {
                    displayText: 'Policies',
                    openInNew: false,
                },
                highlight: false,
                subMenu: [
                    {
                        highlight: false,
                        link: {
                            displayText: 'Cookie policy',
                            href: '/legal/cookie-policy',
                            openInNew: false,
                        },
                    },
                    {
                        highlight: false,
                        link: {
                            displayText: 'Security and privacy',
                            href: '/legal/privacy-notice',
                            openInNew: false,
                        },
                    },
                    {
                        highlight: false,
                        link: {
                            displayText: 'Terms of use',
                            href: '/legal/terms-of-use',
                            openInNew: false,
                        },
                    },
                    {
                        highlight: false,
                        link: {
                            displayText: 'Modern Slavery Statement',
                            href: '/assets/modern-day-slavery-statement.pdf',
                            openInNew: false,
                        },
                    },
                    {
                        highlight: false,
                        link: {
                            displayText: 'Sitemap',
                            href: '/sitemap',
                            openInNew: false,
                        },
                    },
                ],
            },
        ],
    },
    socialMediaIcons: [
        {
            displayText: 'Twitter',
            href: 'https://twitter.com/cottagescom',
            openInNew: true,
            rel: 'noopener',
        },
        {
            displayText: 'Facebook',
            href: 'https://www.facebook.com/cottagescom',
            openInNew: true,
            rel: 'noopener',
        },
        {
            displayText: 'Instagram',
            href: 'https://instagram.com/cottagescom',
            openInNew: true,
            rel: 'noopener',
        },
        {
            displayText: 'Pinterest',
            href: 'https://www.pinterest.co.uk/cottagescom/',
            openInNew: true,
            rel: 'noopener',
        },
        {
            displayText: 'YouTube',
            href: 'https://www.youtube.com/channel/UCbB65-ewEUmoEuiq1jjC1qQ',
            openInNew: true,
            rel: 'noopener',
        },
        {
            displayText: 'Linkedin',
            href: 'https://uk.linkedin.com/company/awaze',
            openInNew: true,
            rel: 'noopener',
        },
    ],
    companyInformation: companyInformation('Cottages.com'),
    termsAndConditions: {
        displayText: 'Terms and Conditions*',
        href: '/legal/booking-conditions',
        openInNew: true,
    },
};
export const footerHoseasonsLabels = {
    id: 'Hoseasons footer',
    panels: [
        {
            title: 'Need help?',
            text: 'If you can’t find the information you need in the Frequently Asked Questions section, our team will be happy to assist.',
            cta: {
                link: '/frequently-asked-questions',
                title: 'FAQs, help and support',
                text: 'FAQs, help and support',
                icon: 'faq',
            },
        },
        {
            title: 'Partner with us',
            text: 'Thinking of letting your property? Benefit from partnering with the UK’s leading managed holiday letting agency.',
            cta: {
                link: '/cottages/let-with-us',
                title: 'Let your property',
                text: 'Let your property',
                icon: 'houseHeart',
            },
        },
        {
            title: 'Book with confidence',
            text: "We're committed to maintaining a high standard of service to our customers by abiding by ABTA's Code of Conduct",
            secondaryText: 'Membership numbers Y0662/L4801',
            icon: 'abta',
            cta: {
                link: '/book-with-confidence',
                title: 'Read full details',
                text: 'Read full details',
                icon: 'shield',
            },
        },
    ],
    menu: {
        menuItems: [
            {
                link: {
                    displayText: 'Company',
                    openInNew: false,
                },
                highlight: false,
                subMenu: [
                    {
                        highlight: false,
                        link: {
                            displayText: 'About Hoseasons',
                            href: '/about-us',
                            openInNew: false,
                        },
                    },
                    {
                        highlight: false,
                        link: {
                            displayText: 'About Awaze',
                            href: 'https://www.awaze.co.uk/',
                            openInNew: true,
                        },
                    },
                    {
                        highlight: false,
                        link: {
                            displayText: 'Gender pay gap',
                            href: '/gender-pay',
                            openInNew: true,
                        },
                    },
                    {
                        highlight: false,
                        link: {
                            displayText: 'Contact us',
                            href: '/contact-us',
                            openInNew: false,
                        },
                    },
                ],
            },
            {
                link: {
                    displayText: 'Customer Information',
                    openInNew: false,
                },
                highlight: false,
                subMenu: [
                    {
                        highlight: false,
                        link: {
                            displayText: 'FAQs, help and support',
                            href: '/frequently-asked-questions',
                            openInNew: false,
                        },
                    },
                    {
                        highlight: false,
                        link: {
                            displayText: 'Booking conditions',
                            href: '/terms-and-conditions',
                            openInNew: false,
                        },
                    },
                    {
                        highlight: false,
                        link: {
                            displayText: 'Buy holiday gift vouchers',
                            href: 'https://www.holiday-voucher.com/',
                            openInNew: true,
                        },
                    },
                    {
                        highlight: false,
                        link: {
                            displayText: 'Discounts and offers',
                            href: '/discounts',
                            openInNew: false,
                        },
                    },
                ],
            },
            {
                link: {
                    displayText: 'Inspiration',
                    openInNew: false,
                },
                highlight: false,
                subMenu: [
                    {
                        highlight: false,
                        link: {
                            displayText: 'Explore the UK',
                            href: '/explore',
                            openInNew: false,
                        },
                    },
                    {
                        highlight: false,
                        link: {
                            displayText: 'Breaks',
                            href: '/breaks',
                            openInNew: false,
                        },
                    },
                    {
                        highlight: false,
                        link: {
                            displayText: 'Collections',
                            href: '/collections',
                            openInNew: false,
                        },
                    },
                    {
                        highlight: false,
                        link: {
                            displayText: 'Seasonal collection',
                            href: '/seasonal',
                            openInNew: false,
                        },
                    },
                    {
                        highlight: false,
                        link: {
                            displayText: 'LGBTQ+ friendly holidays',
                            href: '/gay-lesbian-holidays',
                            openInNew: false,
                        },
                    },
                ],
            },
            {
                link: {
                    displayText: 'Policies',
                    openInNew: false,
                },
                highlight: false,
                subMenu: [
                    {
                        highlight: false,
                        link: {
                            displayText: 'Cookie policy',
                            href: '/cookie-policy',
                            openInNew: false,
                        },
                    },
                    {
                        highlight: false,
                        link: {
                            displayText: 'Security and privacy',
                            href: '/security-and-privacy',
                            openInNew: false,
                        },
                    },
                    {
                        highlight: false,
                        link: {
                            displayText: 'Terms of use',
                            href: '/terms-of-use',
                            openInNew: false,
                        },
                    },
                    {
                        highlight: false,
                        link: {
                            displayText: 'Modern Slavery Statement',
                            href: 'https://www.hoseasons.co.uk/assets/modern-day-slavery-statement.pdf?v=2ad46e50a664701ab4da430fd6248eb7',
                            openInNew: false,
                        },
                    },
                ],
            },
        ],
    },
    socialMediaIcons: [
        {
            displayText: 'Twitter',
            href: 'https://twitter.com/Hoseasons',
            openInNew: true,
            rel: 'noopener',
        },
        {
            displayText: 'Facebook',
            href: 'https://www.facebook.com/hoseasons',
            openInNew: true,
            rel: 'noopener',
        },
        {
            displayText: 'Instagram',
            href: 'https://www.instagram.com/hoseasons',
            openInNew: true,
            rel: 'noopener',
        },
        {
            displayText: 'Pinterest',
            href: 'https://www.pinterest.co.uk/hoseasons/',
            openInNew: true,
            rel: 'noopener',
        },
        {
            displayText: 'YouTube',
            href: 'https://www.youtube.com/user/HoseasonsTV',
            openInNew: true,
            rel: 'noopener',
        },
        {
            displayText: 'Linkedin',
            href: 'https://uk.linkedin.com/company/awaze',
            openInNew: true,
            rel: 'noopener',
        },
    ],
    companyInformation: companyInformation('Hoseasons'),
    termsAndConditions: {
        displayText: 'Terms and Conditions*',
        href: '/terms-and-conditions',
        openInNew: true,
    },
};
export const footerNovasolLabels = {
    id: 'Novasol footer',
    panels: [
        {
            title: 'Need help?',
            text: 'If you can’t find the information you need in the Frequently Asked Questions section, our team will be happy to assist.',
            cta: {
                link: '/frequently-asked-questions',
                title: 'FAQs, help and support',
                text: 'FAQs, help and support',
                icon: 'faq',
            },
        },
        {
            title: 'Partner with us',
            text: 'Thinking of letting your property? Benefit from partnering with the UK’s leading managed holiday letting agency.',
            cta: {
                link: '/cottages/let-with-us',
                title: 'Let your property',
                text: 'Let your property',
                icon: 'houseHeart',
            },
        },
    ],
    menu: {
        menuItems: [
            {
                link: {
                    displayText: 'Company',
                    openInNew: false,
                },
                highlight: false,
                subMenu: [
                    {
                        highlight: false,
                        link: {
                            displayText: 'About Novasol',
                            href: '/about-us',
                            openInNew: false,
                        },
                    },
                    {
                        highlight: false,
                        link: {
                            displayText: 'About Awaze',
                            href: 'https://www.awaze.co.uk/',
                            openInNew: true,
                        },
                    },
                    {
                        highlight: false,
                        link: {
                            displayText: 'Gender pay gap',
                            href: '/gender-pay',
                            openInNew: true,
                        },
                    },
                    {
                        highlight: false,
                        link: {
                            displayText: 'Contact us',
                            href: '/contact-us',
                            openInNew: false,
                        },
                    },
                ],
            },
            {
                link: {
                    displayText: 'Customer Information',
                    openInNew: false,
                },
                highlight: false,
                subMenu: [
                    {
                        highlight: false,
                        link: {
                            displayText: 'FAQs, help and support',
                            href: '/frequently-asked-questions',
                            openInNew: false,
                        },
                    },
                    {
                        highlight: false,
                        link: {
                            displayText: 'Booking conditions',
                            href: '/terms-and-conditions',
                            openInNew: false,
                        },
                    },
                    {
                        highlight: false,
                        link: {
                            displayText: 'Buy holiday gift vouchers',
                            href: 'https://www.holiday-voucher.com/',
                            openInNew: true,
                        },
                    },
                    {
                        highlight: false,
                        link: {
                            displayText: 'Discounts and offers',
                            href: '/discounts',
                            openInNew: false,
                        },
                    },
                ],
            },
            {
                link: {
                    displayText: 'Inspiration',
                    openInNew: false,
                },
                highlight: false,
                subMenu: [
                    {
                        highlight: false,
                        link: {
                            displayText: 'Explore the UK',
                            href: '/explore',
                            openInNew: false,
                        },
                    },
                    {
                        highlight: false,
                        link: {
                            displayText: 'Breaks',
                            href: '/breaks',
                            openInNew: false,
                        },
                    },
                    {
                        highlight: false,
                        link: {
                            displayText: 'Collections',
                            href: '/collections',
                            openInNew: false,
                        },
                    },
                    {
                        highlight: false,
                        link: {
                            displayText: 'Seasonal collection',
                            href: '/seasonal',
                            openInNew: false,
                        },
                    },
                    {
                        highlight: false,
                        link: {
                            displayText: 'LGBTQ+ friendly holidays',
                            href: '/gay-lesbian-holidays',
                            openInNew: false,
                        },
                    },
                ],
            },
            {
                link: {
                    displayText: 'Policies',
                    openInNew: false,
                },
                highlight: false,
                subMenu: [
                    {
                        highlight: false,
                        link: {
                            displayText: 'Cookie policy',
                            href: '/cookie-policy',
                            openInNew: false,
                        },
                    },
                    {
                        highlight: false,
                        link: {
                            displayText: 'Security and privacy',
                            href: '/security-and-privacy',
                            openInNew: false,
                        },
                    },
                    {
                        highlight: false,
                        link: {
                            displayText: 'Terms of use',
                            href: '/terms-of-use',
                            openInNew: false,
                        },
                    },
                    {
                        highlight: false,
                        link: {
                            displayText: 'Modern Slavery Statement',
                            href: 'https://www.hoseasons.co.uk/assets/modern-day-slavery-statement.pdf?v=2ad46e50a664701ab4da430fd6248eb7',
                            openInNew: false,
                        },
                    },
                ],
            },
        ],
    },
    socialMediaIcons: [
        {
            displayText: 'Facebook',
            href: 'https://www.facebook.com/novasol',
            openInNew: true,
            rel: 'noopener',
        },
        {
            displayText: 'Instagram',
            href: 'https://www.instagram.com/novasol',
            openInNew: true,
            rel: 'noopener',
        },
    ],
    companyInformation: companyInformation('Novasol'),
    termsAndConditions: {
        displayText: 'Terms and Conditions*',
        href: '/terms-and-conditions',
        openInNew: true,
    },
};
export const footerFincallorcaLabels = {
    id: 'Fincallorca footer',
    panels: [
        {
            title: 'Need help?',
            text: 'If you can’t find the information you need in the Frequently Asked Questions section, our team will be happy to assist.',
            cta: {
                link: '/frequently-asked-questions',
                title: 'FAQs, help and support',
                text: 'FAQs, help and support',
                icon: 'faq',
            },
        },
        {
            title: 'Partner with us',
            text: 'Thinking of letting your property? Benefit from partnering with the UK’s leading managed holiday letting agency.',
            cta: {
                link: '/cottages/let-with-us',
                title: 'Let your property',
                text: 'Let your property',
                icon: 'houseHeart',
            },
        },
    ],
    menu: {
        menuItems: [
            {
                link: {
                    displayText: 'Company',
                    openInNew: false,
                },
                highlight: false,
                subMenu: [
                    {
                        highlight: false,
                        link: {
                            displayText: 'About Fincallorca',
                            href: '/about-us',
                            openInNew: false,
                        },
                    },
                    {
                        highlight: false,
                        link: {
                            displayText: 'About Awaze',
                            href: 'https://www.awaze.co.uk/',
                            openInNew: true,
                        },
                    },
                    {
                        highlight: false,
                        link: {
                            displayText: 'Press and media',
                            href: '/press',
                            openInNew: false,
                        },
                    },
                    {
                        highlight: false,
                        link: {
                            displayText: 'Gender pay gap',
                            href: '/gender-pay',
                            openInNew: true,
                        },
                    },
                    {
                        highlight: false,
                        link: {
                            displayText: 'Our green scheme',
                            href: '/our-green-scheme',
                            openInNew: false,
                        },
                    },
                ],
            },
            {
                link: {
                    displayText: 'Customer Information',
                    openInNew: false,
                },
                highlight: false,
                subMenu: [
                    {
                        highlight: false,
                        link: {
                            displayText: 'FAQs, help and support',
                            href: '/frequently-asked-questions',
                            openInNew: false,
                        },
                    },
                    {
                        highlight: false,
                        link: {
                            displayText: 'Important holiday information',
                            href: '/important-holiday-information',
                            openInNew: false,
                        },
                    },
                    {
                        highlight: false,
                        link: {
                            displayText: 'Pay balance',
                            href: '/pay-balance',
                            openInNew: false,
                        },
                    },
                    {
                        highlight: false,
                        link: {
                            displayText: 'Insurance',
                            href: '/insurance',
                            openInNew: false,
                        },
                    },
                    {
                        highlight: false,
                        link: {
                            displayText: 'Ferry travel',
                            href: '/ferry-travel',
                            openInNew: false,
                        },
                    },
                    {
                        highlight: false,
                        link: {
                            displayText: 'Booking conditions',
                            href: '/booking-conditions',
                            openInNew: false,
                        },
                    },
                    {
                        highlight: false,
                        link: {
                            displayText: 'Buy holiday gift vouchers',
                            href: 'https://www.holiday-voucher.com/',
                            openInNew: true,
                        },
                    },
                ],
            },
            {
                link: {
                    displayText: 'Inspiration',
                    openInNew: false,
                },
                highlight: false,
                subMenu: [
                    {
                        highlight: false,
                        link: {
                            displayText: 'Travel guides',
                            href: '/travel-guides',
                            openInNew: false,
                        },
                    },
                    {
                        highlight: false,
                        link: {
                            displayText: 'Breaks',
                            href: '/breaks',
                            openInNew: false,
                        },
                    },
                    {
                        highlight: false,
                        link: {
                            displayText: 'Collections',
                            href: '/collections',
                            openInNew: false,
                        },
                    },
                    {
                        highlight: false,
                        link: {
                            displayText: 'Seasonal',
                            href: '/seasonal',
                            openInNew: false,
                        },
                    },
                    {
                        highlight: false,
                        link: {
                            displayText: 'Blog',
                            href: '/blog',
                            openInNew: false,
                        },
                    },
                    {
                        highlight: false,
                        link: {
                            displayText: 'Videos',
                            href: '/videos',
                            openInNew: false,
                        },
                    },
                ],
            },
            {
                link: {
                    displayText: 'Policies',
                    openInNew: false,
                },
                highlight: false,
                subMenu: [
                    {
                        highlight: false,
                        link: {
                            displayText: 'Cookie policy',
                            href: '/cookie-policy',
                            openInNew: false,
                        },
                    },
                    {
                        highlight: false,
                        link: {
                            displayText: 'Security and privacy',
                            href: '/security-and-privacy',
                            openInNew: false,
                        },
                    },
                    {
                        highlight: false,
                        link: {
                            displayText: 'Terms of use',
                            href: '/terms-of-use',
                            openInNew: false,
                        },
                    },
                    {
                        highlight: false,
                        link: {
                            displayText: 'Modern Slavery Statement',
                            href: 'https://www.hoseasons.co.uk/assets/modern-day-slavery-statement.pdf?v=2ad46e50a664701ab4da430fd6248eb7',
                            openInNew: false,
                        },
                    },
                    {
                        highlight: false,
                        link: {
                            displayText: 'Sitemap',
                            href: '/sitemap',
                            openInNew: false,
                        },
                    },
                ],
            },
        ],
    },
    socialMediaIcons: [
        {
            displayText: 'Facebook',
            href: 'https://www.facebook.com/novasol',
            openInNew: true,
            rel: 'noopener',
        },
        {
            displayText: 'Instagram',
            href: 'https://www.instagram.com/novasol',
            openInNew: true,
            rel: 'noopener',
        },
        {
            displayText: 'YouTube',
            href: 'https://www.youtube.com/@fincallorca',
            openInNew: true,
            rel: 'noopener',
        },
    ],
    companyInformation: companyInformation('Fincallorca'),
    termsAndConditions: {
        displayText: 'Terms and Conditions*',
        href: '/terms-and-conditions',
        openInNew: true,
    },
};
//# sourceMappingURL=footer.data.js.map